import { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-number-input';
import { BASEAPIURL, getDefaultCountry } from '../../../config';

function ContactUs() {
    const [APICall, SetAPICall] = useState(false);
    const [styleBTN, setstyleBTN] = useState({});
    const [styleMSG, setstyleMSG] = useState({ display: 'none' });
    const numberToTextMap = {
        1: "One",
        2: "Two",
        3: "Three",
        4: "Four",
        5: "Five",
        6: "Six",
        7: "Seven",
        8: "Eight",
        9: "Nine",
      };
    const [Message, setMessage] = useState(
        `<img src="/assets/img/loader.gif" style="max-width: 70px; margin: 0px auto; display: block;" />`
    );
    const [ContactForm, setContactForm] = useState({
        fname: '',
        lname: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        captcha1: Math.floor(Math.random() * 9) + 1,
        captcha2: Math.floor(Math.random() * 9) + 1,
        captcha: '',
    });
    useEffect(() => {
        const token = localStorage.getItem('userdata');
        if (token) {
            const userdata = JSON.parse(token);
            if (userdata) {
                setContactForm({
                    ...ContactForm,
                    email: userdata.email ? userdata.email : '',
                    phone: userdata.mobile ? userdata.mobile : '',
                    fname: userdata.name ? userdata.name : ''
                });
            }
        }
    }, [])

    const setPhoneNumber = (value) => {
        setContactForm({ ...ContactForm, phone: value });
    };

    const HandleForm = (name, value) => {
        setContactForm({ ...ContactForm, [name]: value });
    };
    
    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const SubmitContactForm = async (e) => {
        setstyleMSG({ display: 'block' });
        e.preventDefault();
        if (ContactForm.fname === '') {
            setMessage("<div class='alert alert-danger'>Please Enter Your Name.</div>");
            return false;
        }
        if (ContactForm.email === '') {
            setMessage("<div class='alert alert-danger'>Please Enter Your Email.</div>");
            return false;
        }
        if (ContactForm.phone === '') {
            setMessage("<div class='alert alert-danger'>Please Enter Your Mobile.</div>");
            return false;
        }
        if (!validateEmail(ContactForm.email)) {
            setMessage("<div class='alert alert-danger'>Please Enter valid Email.</div>");
            return false;
        }
        if (Number(ContactForm.captcha) !== Number(ContactForm.captcha2) + Number(ContactForm.captcha1)) {
            setMessage("<div class='alert alert-danger'>Please Enter Correct Addition on Human Verification.</div>");
            // return false;
        }
        setMessage(
            `<img src="/assets/img/loader.gif" style="max-width: 70px; margin: 0px auto; display: block;" />`
        );
        SetAPICall(true);
        try {
            const res = await fetch(`${BASEAPIURL}/institute/enquiry/send-contact-us`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "X-User-Validation": ContactForm.captcha1 + ContactForm.captcha2, // Send captcha input in header 
                    "X-User-Input": ContactForm.captcha, // Send expected answer in header
                },
                body: JSON.stringify(ContactForm),
            });
            setstyleBTN({ display: 'none' });

            const resJson = await res.json();
            // alert(res.status);
            SetAPICall(false);
            if (resJson.status === 1) {
                setContactForm({
                    fname: '',
                    lname: '',
                    email: '',
                    phone: '',
                    subject: '',
                    message: '',
                    captcha1: Math.floor(Math.random() * 9) + 1,
                    captcha2: Math.floor(Math.random() * 9) + 1,
                    captcha: '',
                });
                setMessage(`<div class="alert alert-success">${resJson.message}</div>`);
            } else {
                setMessage(`<div class="alert alert-danger">${resJson.message}</div>`);
            }
            setstyleBTN({ display: '' });
        } catch (err) {
            setstyleBTN({ display: '' });
            SetAPICall(false);
            setMessage(`<div class="alert alert-danger">${err.message}</div>`);
        }
    };

    return (
        <>
            <section
                className="corporate-learning"
                data-overlay="6"
                style={{
                    backgroundImage: `url(assets/img/why-bg.jpg)`,
                    padding: '70px 10px',
                    backgroundPosition: 'center',
                    backgroundAttachment: 'fixed',
                }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="headBlock">
                                <h1 className="mt-5 text-white mb-2">Contact Us</h1>
                                <p className="mb-5">We're always eager to hear from you!</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="contact-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="contact--info-area">
                                <h3>Get in touch</h3>
                                <p>We're always eager to hear from you!</p>
                                <div className="single-info">
                                    <h5>Address</h5>
                                    <p>
                                        <i className="fal fa-map-marker-alt" />
                                        Office no.14, 3rd floor,
                                        <br />Mohd. Bin Rashid Al Maktoum Charitable and Humanitarian Foundation,
                                        <br />P.O. Box  82378
                                        <br />Al Mamzar, Dubai-UAE
                                    </p>
                                </div>
                                <div className="single-info">
                                    <h5>Call us</h5>
                                    <p>
                                        <i className="fal fa-phone" />
                                        <a href="tel:+97147187101">+971 4 7187101</a>
                                    </p>
                                </div>
                                <div className="single-info">
                                    <h5>Email</h5>
                                    <p>
                                        <i className="fal fa-envelope" />
                                        <a href="mailto:info@acumenglow.com">info@acumenglow.com</a>
                                    </p>
                                </div>
                                <div className="single-info">
                                    <h5>Hours of Operation</h5>
                                    <p>
                                        <i className="fal fa-clock" />
                                        Mon - Fri 9 am to 5:30 pm (GST)
                                    </p>
                                </div>
                                <div className="ab-social">
                                    <h5>Social Media</h5>
                                    <a
                                        className="you"
                                        href="https://www.youtube.com/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="fab fa-youtube" />
                                    </a>
                                    <a
                                        className="fac"
                                        href="https://www.facebook.com/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="fab fa-facebook-f" />
                                    </a>
                                    <a
                                        className="lin"
                                        href="https://www.linkedin.com/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="fab fa-linkedin-in" />
                                    </a>
                                    <a
                                        className="inst"
                                        href="https://www.instagram.com/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="fab fa-instagram" />
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="contact-form">
                                <h4>Let's Connect</h4>
                                <p>
                                    Fill the form below so we can get to know you and your needs
                                    better.
                                </p>
                                <form
                                    method="post"
                                    className="row"
                                    onSubmit={(e) => {
                                        SubmitContactForm(e);
                                    }}
                                >
                                    <div className="col-md-12">
                                        <label>Name</label>
                                        <input
                                            type="text"
                                            name="fname"
                                            value={ContactForm.fname}
                                            placeholder="Enter Your Name"
                                            onChange={(e) => {
                                                HandleForm(e.target.name, e.target.value);
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label><i className='fa fa-envelope'></i> Email</label>
                                        <input
                                            type="text"
                                            name="email"
                                            value={ContactForm.email}
                                            placeholder="Enter Email ID"
                                            onChange={(e) => {
                                                HandleForm(e.target.name, e.target.value);
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label><i className='fa fa-phone'></i> Mobile</label>
                                        <PhoneInput
                                            type="phone"
                                            required
                                            international
                                            defaultCountry={getDefaultCountry()}
                                            className="form-control"
                                            name="phonenumber"
                                            value={ContactForm.phone}
                                            onChange={setPhoneNumber}
                                            style={{ position: 'relative' }}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <label>Message</label>
                                        <textarea
                                            required
                                            name="message"
                                            value={ContactForm.message}
                                            placeholder="How can we help?"
                                            onChange={(e) => {
                                                HandleForm(e.target.name, e.target.value);
                                            }}
                                        ></textarea>
                                    </div>

                                    <div className="col-md-6 text-left mt-2">
                                        <label>Human Verification</label>
                                        <br />
                                        <small>( Enter {numberToTextMap[ContactForm.captcha1]} + {numberToTextMap[ContactForm.captcha2]} )</small>
                                    </div>
                                    <div className="col-md-6 text-left mt-2">
                                        <input
                                            name="captcha"
                                            type="text"
                                            min={0}
                                            className='form-control'
                                            value={ContactForm.captcha}
                                            placeholder="Enter Captcha Addition"
                                            onChange={(e) => {
                                                HandleForm(e.target.name, e.target.value);
                                            }}
                                        />
                                    </div>

                                    <div className="col-md-12" style={{ clear: 'both' }}>
                                        <div
                                            style={styleMSG}
                                            dangerouslySetInnerHTML={{ __html: Message }}
                                        ></div>
                                    </div>
                                    {APICall && <imgs rc="/assets/img/loader.gif" alt="" />}
                                    <div style={styleBTN} className="col-md-12 text-center mt-2">
                                        <input
                                            type="submit"
                                            disabled={APICall}
                                            name="submit"
                                            value="Send Message"
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="bisylms-map">
                <iframe
                    title="map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3607.27618063474!2d55.3483868760843!3d25.294923427734254!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5dc47f4a5989%3A0x4221b7758e505021!2sAcumen%20Global%20Training%20and%20Development!5e0!3m2!1sen!2sin!4v1736318624686!5m2!1sen!2sin"
                    width="100%"
                    height="100%"
                ></iframe>
            </div>
        </>
    );
}

export default ContactUs;
